import { Box, InputAdornment, TextField, Typography } from '@mui/material'
import { Search24Regular } from '@/components/Icon'
import styles from './integrationsModal.module.scss'

/**
 * @param {{
 *   query: string,
 *   onQueryChange: (q: string) => void,
 *   visibleCount: number,
 *   totalCount: number,
 * }} props
 */
export default function IntegrationsModalToolbar({ query, onQueryChange, visibleCount, totalCount }) {
  return (
    <Box className={styles.toolbar}>
      <Box className={styles.toolbarTop}>
        <TextField
          size="small"
          variant="outlined"
          placeholder="Search integrations..."
          value={query}
          onChange={(e) => onQueryChange(e.target.value)}
          className={styles.searchField}
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <Search24Regular className={styles.searchIcon} aria-hidden />
                </InputAdornment>
              ),
            },
          }}
        />
      </Box>
      <Typography component="p" className={styles.statusLine}>
        Showing {visibleCount} of {totalCount} toolkits
      </Typography>
    </Box>
  )
}
